import React, { useContext } from 'react';
import { IoIosRefresh } from 'react-icons/io';

import { ComponentContext } from '../../context/componentContext';

const UnexpectedError = ({ error, unexpectedError }) => {
  const { reload, setReload, setUnexpectedError } = useContext(ComponentContext);
  if (!error && !unexpectedError) return null;

  return (
    <div className="unexpected-error text-center md:p-32 p-10">
      <h6 className="font-bold text-red-500">{error || unexpectedError}</h6>
      <p className="font-bold">Sorry about this, it wasn't meant to happen.</p>
      <p className="text-sm">
        {unexpectedError && 'Reload page or '}Contact support to help resolve this issue.
      </p>
      <div className="flex justify-center">
        <div
          className="text-cf-300 cursor-pointer"
          onClick={() => {
            setReload(reload + 1);
            setUnexpectedError(null);
          }}
        >
          <IoIosRefresh size={50} />
          <p className="text-xs">Reload</p>
        </div>
      </div>
    </div>
  );
};

export default UnexpectedError;
